import { Stack, Typography } from '@mui/material';

import { TableDeploymentStatus } from '../types';
import { iconForStatus } from '../utils';
import { Container } from './styled';
import { VersionsCountByStatusProps } from './types';

function VersionsCountByStatus({ options }: VersionsCountByStatusProps) {
  return (
    <Container>
      {options.map(([status, count]) => (
        <Stack key={status} direction="row" gap={0.5} alignItems="center">
          {iconForStatus[status]}
          <Typography variant="h5">
            {status === TableDeploymentStatus.Other ? '+' : ''}
            {count}
          </Typography>
        </Stack>
      ))}
    </Container>
  );
}

export default VersionsCountByStatus;
